module.exports = __webpack_public_path__ + "media/images/athletes/2411-3f9f5441f92a6124d83876888255aef3.png";